export default __webpack_public_path__ + "static/marquise-3288374b903af5c7070304ba9c14bf68.png";